import React from "react";

export default ({ label }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="32"
    width="32"
    viewBox="0 0 31.999999 31.999998"
    alt={label}
  >
    <path
      d="m 13,1045.4 c -0.554,0 -1,0.446 -1,1 0,0.554 0.446,1 1,1 l 2,0 c 0.554,0 1,-0.446 1,-1 0,-0.554 -0.446,-1 -1,-1 l -2,0 z m 1.834,-4 c -0.46167,0 -0.83398,0.446 -0.83398,1 0,0.554 0.37231,1 0.83398,1 l 3.332,0 c 0.46167,0 0.83398,-0.446 0.83398,-1 0,-0.554 -0.37231,-1 -0.83398,-1 l -3.332,0 z m 0.94336,-4 c -0.43089,0 -0.77734,0.446 -0.77734,1 0,0.554 0.34645,1 0.77734,1 l 5.4453,0 c 0.43089,0 0.77734,-0.446 0.77734,-1 0,-0.554 -0.34645,-1 -0.77734,-1 l -5.4453,0 z m -0.95703,-4 c -0.46893,0 -0.8457,0.446 -0.8457,1 0,0.554 0.37677,1 0.8457,1 l 9.334,0 c 0.46893,0 0.8457,-0.446 0.8457,-1 0,-0.554 -0.37677,-1 -0.8457,-1 l -9.334,0 z m -5.031,-4 c -0.43737,0 -0.78929,0.446 -0.78929,1 0,0.554 0.35192,1 0.78929,1 l 13.421,0 c 0.43737,0 0.78929,-0.446 0.78929,-1 0,-0.554 -0.35192,-1 -0.78929,-1 l -13.421,0 z m -4.8726,-4 c -0.50785,0 -0.91667,0.446 -0.91667,1 0,0.554 0.40882,1 0.91667,1 l 20.167,0 c 0.50785,0 0.91667,-0.446 0.91667,-1 0,-0.554 -0.40882,-1 -0.91667,-1 l -20.167,0 z"
      transform="translate(0 -1021.4)"
    />
  </svg>
);
